import { Map } from "@evergis/sgis/es/Map";
export const map = new Map();
